import { create } from 'zustand';
import { useComposerStore } from '@/store/useComposerStore';

export interface EventComposerAttendee {
  email: string;
  optional: boolean;
}

export interface EventComposerDraft {
  title: string;
  startAt: string;
  endAt: string;
  isAllDay: boolean;
  location: string;
  description: string;
  attendees: EventComposerAttendee[];
  sendInvite: boolean;
  accountId: number | null;
  providerCalendarId?: string;
}

interface EventComposerState {
  isOpen: boolean;
  isMinimized: boolean;
  draft: EventComposerDraft;
  openEventCompose: (prefill?: Partial<EventComposerDraft>) => void;
  closeEventCompose: () => void;
  minimize: () => void;
  restore: () => void;
  setDraft: (patch: Partial<EventComposerDraft>) => void;
}

const EMPTY_DRAFT: EventComposerDraft = {
  title: '',
  startAt: '',
  endAt: '',
  isAllDay: false,
  location: '',
  description: '',
  attendees: [],
  sendInvite: false,
  accountId: null,
  providerCalendarId: undefined,
};

export const useEventComposerStore = create<EventComposerState>((set) => ({
  isOpen: false,
  isMinimized: false,
  draft: { ...EMPTY_DRAFT },
  openEventCompose: (prefill) => {
    useComposerStore.getState().closeCompose();
    set({ isOpen: true, isMinimized: false, draft: { ...EMPTY_DRAFT, ...prefill } });
  },
  closeEventCompose: () => set({ isOpen: false, isMinimized: false, draft: { ...EMPTY_DRAFT } }),
  minimize: () => set({ isMinimized: true }),
  restore: () => set({ isMinimized: false }),
  setDraft: (patch) => set((s) => ({ draft: { ...s.draft, ...patch } })),
}));
